export enum SubscriptionType {
  Free = 'Free',
  Premium = 'Premium',
  Starter = 'Starter',
  Enterprise = 'Enterprise'
}

export enum PlanType {
  BYOK_FREE = 'byok_free',
  BYOK_PRO = 'byok_pro',
  NOKEY_STARTER = 'noKey_starter',
  NOKEY_PRO = 'noKey_pro'
}

export enum CycleType {
  Monthly = 'monthly',
  Yearly = 'yearly'
}

export enum SubscriptionPackageState {
  active = 'active',
  not_started = 'not_started'
}

export interface SubscribUsagePackage {
  name: SubscriptionType;
  type: CycleType;
  startTime: string;
  endTime: string;
}

export interface SubscriptionUsageCount {
  creditTotal: number; // 套餐内总量 -1=unlimited
  creditUsed: number; // 已使用的套餐轮数
  freeQuotaTotal: number; // 套餐外的可用量
  freeQuotaUsed: number; // 加油包已使用的轮数
}

export interface SubscriptionUsageManageConfig {
  hardLimit?: number;
  softLimit?: number;
  emailList?: string[];
}

export interface SubscriptionUsagePerDayListItem {
  date: string;
  creditUsed: number; // 付费额度用量
  freeQuotaUsed: number; // 赠送额度用量
}
export interface SubscriptionUsagePerDayList {
  billingPeriodStartDate: string;
  dailyUsedDetailList: SubscriptionUsagePerDayListItem[];
}
export interface BillingInvoicesListItem {
  invoiceNo: string;
  date: string;
  amount: string;
  currency: string;
  plan: string;
  messages: number;
}

export interface PackageDetailInfoItem {
  title: string;
  info?: string;
}

export interface PackageDetailMetadata {
  memories: number;
  gpt4messages: number;
  gpt35messages: number;
  identityOutputs: number;
  interval: EPlanInterval;
  [key: string]: string | number;
}

export interface PackageDetailInfo {
  priceId: string;
  alias: EPlanAlias;
  price: number;
  pricePerMonth: number;
  newRightsList: PackageDetailInfoItem[];
  metadata: PackageDetailMetadata;
}

export interface CreatePaymentRequest {
  priceId?: string;
  mode: 'subscription' | 'payment';
  isQuantityOptional?: boolean;
  successUrl: string;
  quantity?: number;
}

export interface UpdateSubscription {
  priceId: string;
  successUrl?: string;
  referralId: string;
}

export interface SubscribeState {
  alias: PlanType;
  intervalTime: CycleType;
  startTime: string;
  endTime: string;
  status: SubscriptionPackageState;
  title: string;
}

export interface AdditionalPackageInfo {
  supplyCredit: number;
  supplyPrice: number;
}

export interface SubscriptionPayment {
  url: string;
}

export interface SelfOpenAIKeyInfo {
  openAIKeyList: string[];
  freeQuotaTotal: number;
  freeQuotaUsed: number;
}

export interface UpdateSelfOpenAIKey {
  key?: string;
}

export enum EPlanAlias {
  FREE = 'byok_free',
  PRO = 'mebot_pro',
  PLUS = 'mebot_plus'
}

export enum EPlanInterval {
  MONTHLY = 'monthly',
  ANNUAL = 'annual'
}

export enum EPlanPlatform {
  APPLE = 'apple',
  STRIPE = 'stripe',
  GOOGLE = 'google'
}

export const PlanAliasWeightMap: Record<EPlanAlias, number> = {
  [EPlanAlias.FREE]: 0,
  [EPlanAlias.PLUS]: 1,
  [EPlanAlias.PRO]: 2
};

export interface CurrentPlanDetail {
  currentPlanAlias: EPlanAlias;
  nextPlanAlias: EPlanAlias;
  planInterval: EPlanInterval;
  renewDate: string;
  platform: EPlanPlatform;
  remain: UsageDetail;
  total: UsageDetail;
  unlimitedExpireDate: string;
}

export interface UsageDetail {
  memories: number;
  gpt4messages: number;
  gpt35messages: number;
  freeMessages: number;
  identityOutputs: number;
}
